import type { Invoice } from '@weft/types';
import { shortenNumber } from 'apps/app/src/utils/number';
import React from 'react';
import { BackButton } from '../../../../components/design/buttons/BackButton';
import { Button } from '../../../../components/design/buttons/Button/Button';
import { InvoiceBillingStatus } from '../../../../components/design/statuses/InvoiceBillingStatus';
import { DownloadIcon } from '../../../../components/icons/DownloadIcon';
import { PrintIcon } from '../../../../components/icons/PrintIcon';

type InvoiceSidebarProps = {
  invoice: Omit<Invoice, 'contract'>;
  totalPrice: number;
  currencySymbol: string;
};

export const InvoiceSidebar:React.FC<InvoiceSidebarProps> = ({
  invoice,
  totalPrice,
  currencySymbol,
}) => {
  return (
    <div className='px-7.5 laptop:min-w-[unset] h-full min-w-[28rem] bg-white py-10'>
      <BackButton/>
      <div className='border-b-line mt-4 border-b pb-5 text-xl font-medium text-black'>Invoice Summary</div>
      <div className='border-b-line laptop:flex-col laptop:items-start mt-5 flex items-center justify-between gap-8 border-b pb-5'>
        <Button
          onClick={() => {}}
          className='whitespace-nowrap px-12 py-3	'
        >
          Invite to Pay
        </Button>
        <div className='laptop:w-full laptop:justify-center flex gap-8'>
          <div className='border-icon cursor-pointer rounded-full border p-3'><DownloadIcon/></div>
          <div className='border-icon cursor-pointer rounded-full border p-3'><PrintIcon/></div>
        </div>
      </div>
      <div className="border-b-line mt-5 border-b pb-5">
        <div className="mb-2 text-base text-black">Amount Due</div>
        <div className="flex flex-wrap items-center gap-4">
          <div className='text-3xl font-medium text-black'>
            <span className='text-xl'>{currencySymbol}</span>
            {shortenNumber(totalPrice)}
          </div>
          <InvoiceBillingStatus invoiceBillingStatus={invoice.billingStatus} />
        </div>
      </div>
    </div>
  );
};